module.exports = __webpack_public_path__ + "img/img1.8d731dba.svg";